<div class="insights-container">
  <div *ngIf="isUserSubmitted && (isExecuting || !finalResponse)" class="mb-7" aria-hidden="true">
    <span><si-loading-spinner /></span> 
    <span class="fw-bold text-secondary">Analyzing insights...</span>
  </div>
  
  @if(finalResponse && !isExecuting && isUserSubmitted) {
  <div class="markdown-content mb-6 code-page-wrapper">
    <div *ngIf="errorMessage">{{errorMessage}}</div>
    <div [hidden]="!finalResponse" [innerHTML]="finalResponse" class="mb-7">
    </div>
  </div>
  }
</div>
